import { B2Cproviders } from "../Interfaces/CommonTypes";
import { getAuthenticationType, getB2CaccessToken, getB2CrefreshToken, getInternalAccessToken, getInternalRefreshToken, getUserId, } from "./TokenHelper";
export var isUserLoggedIn = function () {
    var b2cRefreshToken = getB2CrefreshToken();
    var internalRefreshToken = getInternalRefreshToken();
    var b2cAccessToken = getB2CaccessToken();
    var internalAccessToken = getInternalAccessToken();
    if (b2cRefreshToken &&
        internalRefreshToken &&
        b2cAccessToken &&
        internalAccessToken &&
        b2cRefreshToken !== "null" &&
        internalRefreshToken !== "null" &&
        b2cAccessToken !== "null" &&
        internalAccessToken !== "null" &&
        b2cRefreshToken !== "undefined" &&
        internalRefreshToken !== "undefined" &&
        b2cAccessToken !== "undefined" &&
        internalAccessToken !== "undefined") {
        return true;
    }
    return false;
};
export var isUserNormalCitizen = function () {
    var authenticationType = getAuthenticationType();
    if (authenticationType &&
        authenticationType !== "null" &&
        authenticationType !== "undefined" &&
        !Number.isNaN(authenticationType) &&
        parseInt(authenticationType) !== B2Cproviders.CORP) {
        return true;
    }
    return false;
};
export var isUserCorp = function () {
    var authenticationType = getAuthenticationType();
    if (authenticationType &&
        authenticationType !== "null" &&
        !Number.isNaN(authenticationType) &&
        parseInt(authenticationType) === B2Cproviders.CORP) {
        return true;
    }
    return false;
};
export var isUserWithProfile = function () {
    var userId = getUserId();
    if (userId && userId !== "null") {
        return true;
    }
    return false;
};
